<template>
  <v-expand-transition>
    <div v-if="filtro.length > 0">
      <v-col class="d-flex align-center pb-md-0 pb-3" cols="8" sm="10" md="12">
        <v-row class="pa-3">
          <v-chip
            v-for="(item, index) in filtro"
            :key="index"
            class="mb-1 ml-1"
            small
          >
            {{ item.value }}
            <v-icon
              class="ml-2"
              @click="$emit('desfiltrar', item)"
            >
              fas fa-times-circle
            </v-icon>
          </v-chip>
        </v-row>
      </v-col>
    </div>
  </v-expand-transition>
</template>

<script>
export default {
  props: {
    value: Array
  },
  computed: {
    filtro: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>